const dequote = (str) => {
  return str.substr(1).slice(0, -1)
}

export default dequote;